import {css} from "lit";
import {iconStyles} from "../../common/styles/Icons.js";
import {labeledTextInputStyles} from "../../common/controls-inputs/LabeledTextInput.styles.js";

export const citationEditorStyles = [iconStyles, labeledTextInputStyles, css`
	#citation-field-label-wrapper {
		display: flex;
		align-items: end;
	}

	#citation-field-label-wrapper :not(:last-child) {
		margin-right: 6px;
	}

	#citation-field-label-wrapper label {
		margin-bottom: 0;
	}

	#citation-editor-warning, #citation-editor-notification {
		margin-left: auto;
		margin-bottom: 2px;
		font-size: var(--pn-font-size-small);
	}

	.hidden {
		display: none;
	}

	#citation-editor-warning:not(.hidden) + #btn-citation-refresh,
	#citation-editor-notification:not(.hidden) + #btn-citation-refresh {
		margin-left: 0;
	}

	#citation-editor-warning {
		color: var(--pn-error-msg-light-bg-color);
	}

	#btn-citation-refresh {
		flex-shrink: 0;
		margin-left: auto;
		font-size: 21px;
		margin-bottom: 3px;
	}

	#btn-citation-refresh::part(i) {
		background-color: var(--pn-button-primary-color);
	}

	#btn-citation-refresh::part(i):hover,
	#btn-citation-refresh::part(i):focus {
		background-color: var(--pn-button-primary-color-hover);
	}

	#btn-citation-refresh::part(i):active {
		background-color: var(--pn-button-primary-color-active);
	}

	/* Note: the spin keyframe is in the IconButton stylesheet */
	#btn-citation-refresh.loading::part(button) {
		animation: spin 3s linear infinite;
	}
	#btn-citation-refresh.loading::part(i) {
		background-color: var(--pn-button-disabled-color);
	}

	pn-rte {
		display: block;
		margin-bottom: 20px;
		font-weight: 500; /* match input, textarea in the citation panel */
	}

	pn-rte::part(editor) {
		height: 90px;
	}
`];
